import { isEmpty } from 'lodash';
import { GetActiveOrganizationRole, GetActiveSubscription } from '@/constants/getters';
import { ROLE_TYPE, SUBSCRIPTION_STATUS } from "@/constants";

// Grant owner access to account related routes;
const OWNER_WHITELISTED_ROUTES = [
  '/account/*',
];

export default function ({ $auth, store, error, route }) {
  const strategy = $auth.strategy;

  if (strategy.token.status().valid() && route.path !== $auth.options?.redirect?.callback) {
    const role = store.getters[`authStore/${GetActiveOrganizationRole}`];
    const subscription = store.getters[`authStore/${GetActiveSubscription}`];

    const isOwner = !!role(ROLE_TYPE.OWNER);
    const isWhitelisted = OWNER_WHITELISTED_ROUTES.some((pattern) => route.path.match(pattern));

    // If the organisation has no subscriptions
    if (isEmpty(subscription)) {
      if (!(isOwner && isWhitelisted)) {
        error({ statusCode: 402 });
      }
    } else {
      switch (subscription?.status) {
        case SUBSCRIPTION_STATUS.TRIAL_EXPIRED:
          if (!(isOwner && isWhitelisted)) {
            error({ statusCode: 402.1 });
          }
          break;
        case SUBSCRIPTION_STATUS.CANCELED:
          if (!(isOwner && isWhitelisted)) {
            error({ statusCode: 402.2 });
          }
          break;
        case SUBSCRIPTION_STATUS.PAYMENT_REQUIRED:
          if (!(isOwner && isWhitelisted)) {
            error({ statusCode: 402.3 });
          }
          break;
      }
    }
  }

  return Promise.resolve();
}
